module.exports = __webpack_public_path__ + "img/3600.d2b61ff9.jpg";